
import {GES} from './app/ges/GES.js';
import {ActiviteHumaine} from './app/activite-humaine/ActiviteHumaine.js';
window.GES = GES;
window.ActiviteHumaine = ActiviteHumaine;
